import { render } from "./Doubtes.vue?vue&type=template&id=5934e7b0&scoped=true"
import script from "./Doubtes.vue?vue&type=script&lang=js"
export * from "./Doubtes.vue?vue&type=script&lang=js"

import "./Doubtes.vue?vue&type=style&index=0&id=5934e7b0&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\comprodonto_site_v4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5934e7b0"]])

export default __exports__